/**
 * @generated SignedSource<<0c4097c6e5b25e93473d036d5c8732b7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type SearchLinkedResultCategory = "child" | "mentionedBy" | "mentions" | "similar" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchResults_AtlassianSearchPage_SearchResultsBody_connectionData$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly __typename: string;
      readonly connectorId?: string | null;
      readonly connectorProduct?: string | null;
      readonly connectorType?: string | null;
      readonly description: string;
      readonly id: string;
      readonly integrationId?: string | null;
      readonly issue?: {
        readonly webUrl: AGG$URL | null;
      } | null;
      readonly linkedResults: ReadonlyArray<{
        readonly category: SearchLinkedResultCategory;
        readonly connectorType: string | null;
        readonly id: string;
      }> | null;
      readonly ownerId?: string | null;
      readonly providerId?: string | null;
      readonly socialSignal?: {
        readonly signal: string | null;
      } | null;
      readonly url?: string;
      readonly " $fragmentSpreads": FragmentRefs<"searchResult_AtlassianSearchPage">;
    } | null;
  }>;
  readonly errors: ReadonlyArray<{
    readonly integration: string | null;
    readonly product: string | null;
    readonly statusCode: number;
  }> | null;
  readonly pageInfo: {
    readonly endCursor: string | null;
    readonly hasNextPage: boolean;
  };
  readonly queryInfo: {
    readonly originalQuery: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"autoCorrection_AtlassianSearchPage">;
  } | null;
  readonly traceId: string | null;
  readonly " $fragmentType": "searchResults_AtlassianSearchPage_SearchResultsBody_connectionData";
};
export type searchResults_AtlassianSearchPage_SearchResultsBody_connectionData$key = {
  readonly " $data"?: searchResults_AtlassianSearchPage_SearchResultsBody_connectionData$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchResults_AtlassianSearchPage_SearchResultsBody_connectionData">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "connectorType"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__isassetsenabledrelayprovider"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeDeactivatedContributors"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeGithubCode"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeJiraLiteModeFields"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeNavBoostScore"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includePassionfruitAsk"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includePositions"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeReactionsAndCommentCount"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeRisk"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeThirdPartyId"
    },
    {
      "kind": "RootArgument",
      "name": "tenantId"
    }
  ],
  "kind": "Fragment",
  "name": "searchResults_AtlassianSearchPage_SearchResultsBody_connectionData",
  "selections": [
    {
      "concreteType": "SearchResultItemEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "__typename"
            },
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "name": "description"
            },
            {
              "concreteType": "SearchLinkedResult",
              "kind": "LinkedField",
              "name": "linkedResults",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "category"
                },
                (v1/*: any*/)
              ]
            },
            {
              "args": [
                {
                  "kind": "Variable",
                  "name": "includeAssets",
                  "variableName": "__relay_internal__pv__isassetsenabledrelayprovider"
                },
                {
                  "kind": "Variable",
                  "name": "includeDeactivatedContributors",
                  "variableName": "includeDeactivatedContributors"
                },
                {
                  "kind": "Variable",
                  "name": "includeGithubCode",
                  "variableName": "includeGithubCode"
                },
                {
                  "kind": "Variable",
                  "name": "includeJiraLiteModeFields",
                  "variableName": "includeJiraLiteModeFields"
                },
                {
                  "kind": "Variable",
                  "name": "includeNavBoostScore",
                  "variableName": "includeNavBoostScore"
                },
                {
                  "kind": "Variable",
                  "name": "includePassionfruitAsk",
                  "variableName": "includePassionfruitAsk"
                },
                {
                  "kind": "Variable",
                  "name": "includePositions",
                  "variableName": "includePositions"
                },
                {
                  "kind": "Variable",
                  "name": "includeReactionsAndCommentCount",
                  "variableName": "includeReactionsAndCommentCount"
                },
                {
                  "kind": "Variable",
                  "name": "includeRisk",
                  "variableName": "includeRisk"
                },
                {
                  "kind": "Variable",
                  "name": "includeThirdPartyId",
                  "variableName": "includeThirdPartyId"
                }
              ],
              "kind": "FragmentSpread",
              "name": "searchResult_AtlassianSearchPage"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "providerId"
                },
                {
                  "kind": "ScalarField",
                  "name": "integrationId"
                },
                (v1/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "connectorId"
                },
                {
                  "kind": "ScalarField",
                  "name": "connectorProduct"
                }
              ],
              "type": "SearchResultGraphDocument"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "ownerId"
                }
              ],
              "type": "SearchResultCompassComponent"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "url"
                },
                {
                  "concreteType": "JiraIssue",
                  "kind": "LinkedField",
                  "name": "issue",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "webUrl"
                    }
                  ]
                }
              ],
              "type": "SearchResultJiraIssue"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "tenantId",
                      "variableName": "tenantId"
                    }
                  ],
                  "concreteType": "SocialSignalSearch",
                  "kind": "LinkedField",
                  "name": "socialSignal",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "signal"
                    }
                  ]
                }
              ],
              "type": "SearchConfluencePageBlogAttachment"
            }
          ]
        }
      ]
    },
    {
      "concreteType": "SearchQueryInfo",
      "kind": "LinkedField",
      "name": "queryInfo",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "originalQuery"
        },
        {
          "kind": "FragmentSpread",
          "name": "autoCorrection_AtlassianSearchPage"
        }
      ]
    },
    {
      "concreteType": "PageInfo",
      "kind": "LinkedField",
      "name": "pageInfo",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "endCursor"
        },
        {
          "kind": "ScalarField",
          "name": "hasNextPage"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "traceId"
    },
    {
      "concreteType": "SearchError",
      "kind": "LinkedField",
      "name": "errors",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "statusCode"
        },
        {
          "kind": "ScalarField",
          "name": "product"
        },
        {
          "kind": "ScalarField",
          "name": "integration"
        }
      ]
    }
  ],
  "type": "SearchItemConnection"
};
})();

(node as any).hash = "3320babccf8d8dfd945b322b9088df9f";

export default node;
